/**
 * Moduł obsługuje formularz powiadomienia o dostępności produktu
 * @type module
 */
app.service('availabilityNotification', function (loading, log, modal, validate, captchaService, account) {

	function isUserEmailNotSame(params) {
		const user = account.user();
		return user.email !== params.email;
	}

	function send($form){
		const product = $form.data('product');
		const email = $form.find('input[type=email]').val();
		const captcha = $form.find('.g-recaptcha-response').val();
		const place = $form.find('[data-toggle="captcha"]').data('place');
		const permissionToElectronicChannelAccepted = $form.find('input[name="permissionToElectronicChannelAccepted"]').is(':checked');
		if ($form.valid()) {
			sendData({product, email, captcha, permissionToElectronicChannelAccepted})
				.then(() => {
					$form.resetForm();
					captchaService.hidePlace(place);
					captchaService.init();
				});
		}
	}

	function sendData(params) {
		loading.start();
		const data = {
			productId: params.product,
			email: params.email,
			"g-recaptcha-response": params.captcha,
			permissionToElectronicChannelAccepted: params.permissionToElectronicChannelAccepted
		}
		if(params.permissionToElectronicChannelAccepted && isUserEmailNotSame(params)) {
			log.event({
				'id': 'newsletter',
				'f03': params.email,
			});
		}
		return $.ajax({
			url: '/notify-product-availability.ltr',
			type: 'POST',
			data: data,
			success: function(json) {
				UA.pageview('/akcje/zapisano-na-powiadomienie/premiera-produktu');
				modal.alert(json.messages[0]);
			},
			error:function(){
				modal.alert('Wystąpił problem z zapisem na powiadomienie. Proszę spróbować później.');
			},
			complete:function(){
				loading.stop();
			}
		});
	}
	
	function validateAvailabilityNotificationForm() {
		console.log('validateAvailabilityNotificationForm');
		$('.product-availability-form').each(function() {
			validate.task('availabilityNotificationForm', {
				form: $(this),
				callback: function (form) {
					send($(form));
				}
			});
		});
	}

	function setEvents() {
		$('.js-availability-notification-modal-open').on('click', function() {
			modal.open('availability-notification-' + $(this).data('product'));
		});
		$('.js-availability-notification-submit').on('click', function() {
			send($(this).closest('.product-availability-form'));
		});
		if($('.product-availability-form').length) {
			validateAvailabilityNotificationForm();
		}
	}

	function init() {
		setEvents();
	}

	return {
		init: init
	};
});
